module.exports = __webpack_public_path__ + "img/eventtype-remind.e1945b4e.svg";